<template>
  <div class="row input-wrapper">
    <div class="col-md-4" v-for="field in normalizedFields" :key="field.key">
      <label :for="`input-${field.key}`">{{ field.label }}</label>
      <div class="input-group m-1">
        <input
          type="text"
          class="form-control mb-1"
          :placeholder="field.label"
          :value="resolveValue(field.key)"
          disabled
        />
      </div>
      <a
        v-if="field.view && resolveValue(field.key)"
        :href="resolveValue(field.key)"
        target="_blank"
        >View Link</a
      >
    </div>
  </div>
</template>

<script>
import { maskNumber, formatDate, resolveNestedKey } from "../utils/utils";
export default {
  props: {
    fields: [Array, Object],
    data: [Object, Array],
  },
  computed: {
    normalizedFields() {
      return Array.isArray(this.fields) ? this.fields : [this.fields];
    },
  },
  methods: {
    resolveValue(key) {
      if (key.includes(".")) {
        const value = resolveNestedKey(this.data, key);
        if (key === "bvnDataId.bvn" && value) {
          return maskNumber(value);
        }
        return value;
      }

      if (key === "annualIncome" && this.data.sourcesOfIncome.length) {
        return this.data.sourcesOfIncome[0].annualIncome || "";
      }

      if (key === "otherIndustry" && this.data.sourcesOfIncome[1]) {
        return this.data.sourcesOfIncome[1].industry || "";
      }

      if (key === "otherAnnualIncome" && this.data.sourcesOfIncome[1]) {
        return this.data.sourcesOfIncome[1].annualIncome || "";
      }

      if (key === "dateOfBirth" && this.data[key]) {
        return formatDate(this.data[key]);
      }

      if (key === "nin" && this.data[key]) {
        return true;
      }

      // if (key === "dateOfIncorporation") {
      // 	return formatDate(this.data["registrationDate"]);
      // }

      if (Array.isArray(this.data)) {
        return this.data.map((item) => item[key]).join(", ");
      }

      const arrayMatch = key.match(/^(\w+)\[(\d+)\]$/);
      if (arrayMatch) {
        const [_, arrayKey, index] = arrayMatch;
        const arrayValue = this.data[arrayKey];
        return Array.isArray(arrayValue)
          ? arrayValue[Number(index)]
          : undefined;
      }
      return this.data[key];
    },
  },
};
</script>

<style scoped>
.input-wrapper {
  row-gap: 15px;
}

label {
  color: #9a9a9a;
}

input {
  background-color: #fafafa;
  font-size: 12px;
}

input:disabled {
  background-color: #f5f5f5;
  color: #71797e;
}

input::placeholder {
  color: #b6b6b4 !important;
  font-size: 12px !important;
}
</style>
